import { DEFAULT_STORE } from "../helpers/paymentConstants";

const geoLocationOptions = {
  enableHighAccuracy: true,
  timeout: 6000,
  maximumAge: 120000,
};

const defaultStoreId = DEFAULT_STORE || "6585R";

export default { geoLocationOptions, defaultStoreId };
